export class TREATMENT_PLAN_STATUS {
    static readonly Pending:string = '00000A32-1000-0000-0000-000000000001';
    static readonly ApprovalNeeded:string = '00000A32-1000-0000-0000-000000000002';
    static readonly RejectedByPatient:string = '00000A32-1000-0000-0000-000000000003';
    static readonly AcceptedByPatient:string = '00000A32-1000-0000-0000-000000000004';
      }